module.exports = __webpack_public_path__ + "static/media/fjordOfSorts.a43d2453.jpg";